module.exports = __webpack_public_path__ + "static/media/fb-logo.62394f7a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Footer/fb-logo.svg
 ** module id = 1309
 ** module chunks = 0
 **/